import React from "react";
import { Link } from "gatsby-plugin-intl";
const helpers = require("../helpers");

import Layout from "../components/layout";

import Section from "../components/organisms/section";
import Header from "../components/organisms/header";
import Footer from "../components/organisms/footer";

import HeaderBrand from "../components/molecules/header-brand";
import FooterBrand from "../components/molecules/footer-brand";
import FooterNav from "../components/molecules/footer-nav";
import FooterCopy from "../components/molecules/footer-copy";
import NavBar from "../components/molecules/navbar";
import HeaderTitle from "../components/molecules/header-title";

import Seo from "../components/atoms/seo";

class Jobs extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <Seo title="Privacy Policy" description="Privacy policy page" />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <Section className="pt-5 pb-5">
          <HeaderTitle title="Privacy Policy" />
          <div>
            <p>
              This privacy policy discloses the privacy practices for Blastic on
              the Website (hereinafter: the “Privacy Policy”). Since we are
              committed to safeguarding your personal data we will explain in
              this Privacy Policy how we will treat your personal data and this
              in accordance with the Belgian Act of 8 December 1992 on the
              protection of privacy in relation to the processing of personal
              data, as may be modified and updated from time to time and in
              accordance with Regulation (EU) 2016/679 of the European
              Parliament and of the Council of 27 April 2016 on the protection
              of natural persons with regard to the processing of personal data
              and on the free movement of such data, and repealing Directive
              95/46/EC as from the moment of its entry into force (hereinafter
              the “Privacy law”). This Privacy Policy allows us to be open and
              transparent, so that you can make meaningful choices about the use
              of your personal data.&nbsp; Our Privacy Policy explains:
            </p>
            <ul>
              <li>Which personal data are collected</li>
              <li>
                How we use your personal data and with whom it may be shared
              </li>
              <li>Your rights in relation to the gathered information</li>
            </ul>
            <p>
              Your personal data will be collected and processed by Blastic, a
              Belgian company with registered office at B-2650 Edegem, Prins
              Boudewijnlaan 41 and known in the Crossroads Bank of Enterprises
              under number BE0846804852.
            </p>
            <p>
              This Privacy Policy is to be read together with our{" "}
              <Link to={helpers.getTrailedUrl("/cookie-policy")}>
                cookie policy
              </Link>{" "}
              We reserve the right to make any changes to our Privacy Policy.
              The most recent version of our Privacy Policy will always be
              available on our Website. This Privacy Policy was revised and
              updated last on December 10th 2018.
            </p>
            <p>
              By using our Website you give us permission to collect your
              personal data for the purposes as indicated in this Privacy
              Policy.
            </p>
            <h2>Which personal data do we collect?</h2>
            <p>We collect different kinds of personal data:</p>
            <ul>
              <li>
                Personal data you give us: For example, your name, address,
                e-mail, telephone number when you enter this information in the
                contact form and any additional information as a result of the
                purchase of services.
              </li>
              <li>
                Personal data we get from your use of our Website or services:
                <ul>
                  <li>
                    Log information: we store some data in server logs that
                    include, but are not limited to:
                    <br />
                    Internet Protocol address;
                    <br />
                    Browser-information;
                    <br />
                    The external website that referred you;&nbsp;
                    <br />
                    The pages you visited on our Website;
                    <br />
                    Time and date of each page visited by you;
                    <br />
                    Details on how you use our services.
                  </li>
                  <li>
                    Device information: we can collect device-specific
                    information e.g. serial number, hardware type, version etc.
                  </li>
                  <li>
                    Local storage: using browser web storage, application data
                    caches and other mechanisms on your device we can collect
                    and store your data (including personal data)
                  </li>
                  <li>
                    Cookies: we use cookies to identify our visitors, to
                    remember your custom preferences (e.g. language), … (for
                    further information on what cookies are and their use, we
                    refer you to our{" "}
                    <Link to={helpers.getTrailedUrl("/cookie-policy")}>
                      cookie policy
                    </Link>
                    ).
                    <br />
                    <br />
                  </li>
                </ul>
              </li>
            </ul>
            <h2>How do we use your personal data?</h2>
            <p>
              We use your personal data to provide, maintain, protect, promote
              and improve our services and to develop new ones. Your personal
              data is only stored for as long as necessary to achieve the
              purposes for which they were collected.
            </p>
            <p>We may use your personal data to:</p>
            <ul>
              <li>
                Communicate with you, namely by providing feedback to questions
                you asked via the contact form and to respond to your job
                applications;
              </li>
              <li>Promote use of our services to you on the Website.</li>
            </ul>
            <p>We will only share your personal data:</p>
            <ul>
              <li>
                With your consent: We will only share personal data with
                companies other than Blastic with your consent. Please be
                advised that if you click on any social media button, the social
                media provider may collect your personal data. In such a case,
                the privacy policy of such a provider will apply.
              </li>
              <li>
                For legal reasons: We may share personal data to meet any
                applicable law or regulation or follow any order from a
                competent supervisory body.
              </li>
              <li>
                With entities who process personal data for us: These entities
                may only process the personal data upon our instructions and for
                the purposes necessary to fulfil the purposes of the processing.
                These entities are equally bound by the Privacy Law.&nbsp;
              </li>
            </ul>
            <h2>Your rights</h2>
            <p>You may ask us to provide you, free of charge, with:</p>
            <ul>
              <li>any personal data we hold about you;</li>
              <li>
                further information concerning the purpose of collecting your
                personal data;&nbsp;
              </li>
              <li>
                additional information about the recipients of your personal
                data or categories of recipients of personal data.
              </li>
            </ul>
            <p>
              You have a right to receive, free of charge, a copy in
              intelligible form of any relevant personal data that is undergoing
              processing.
            </p>
            <p>
              Any incorrect, irrelevant and incomplete personal data as well as
              any personal data that infringes your fundamental rights, will be,
              upon request, deleted or corrected free of charge.
            </p>
            <p>
              You may instruct us not to process any of your personal data or
              you may object to the processing of personal data (provided that
              you give a compelling and legitimate reason) free of charge.
            </p>
            <p>
              We shall under no circumstances process personal data revealing
              racial or ethnic origin, political opinions, religious or
              philosophical beliefs or any personal data concerning health or
              sex life.
            </p>
            <h2>Contact information</h2>
            <p>
              In the event you have questions relating to the processing of your
              personal data, or in the event you wish to submit a request for
              access to, modification of or deletion of your personal data, or
              in the event you wish to object to the processing of your personal
              data, you may send us an e-mail at privacy@blastic.com). We will
              provide you with the relevant information or an answer as soon as
              reasonably possible, but in any event no later than 30 days after
              the receipt of the request in case of a request for access and 30
              days after submission in case of an objection to the processing or
              a request for modification or erasure.
            </p>
          </div>
        </Section>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export default Jobs;
